<template>

  <div class="product">
    <!--搜索-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        
        <el-form-item>
          <el-button size="small" @click="addClick()" type="success" icon="el-icon-search" v-auth="'/plus/ranking/index/add'">添加</el-button>
        </el-form-item>
      </el-form>
    </div>



    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table  size="small" :data="tableData" border style="width: 100%" v-loading="loading">

          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="sort" label="排序" width="120"></el-table-column>
          <el-table-column prop="status" label="状态" >
            <template  slot-scope="scope">
               <div >
                  <p v-if="scope.row.status==0">关闭</p>
                  <p v-else>开启</p>
               </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="create_time" label="创建时间" width="135"></el-table-column>
          <el-table-column prop="create_time" label="修改时间" width="135"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/plus/ranking/index/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/plus/ranking/index/del'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="Oneform.model" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>


<script>
  import RankingApi from '@/api/ranking.js';
  import Add from './dialog/Add.vue';
  import Edit from './dialog/Edit.vue';
  export default {
    components: {
      /*编辑组件*/
      Add,
      Edit
    },
    data() {
      return {
        //加载
        loading: true,// true 为加载中   false 加载结束
        // 选项卡控制
        activeName: 'all',
        //搜索控制
        searchForm: {
          user_id: ''  ,//用户id
          nickName:'',
          mobile:'',
          merger_name:'',
          province_id: '',
          city_id: '',
          region_id: '',
          street_id: '',
        },
        //表格数据
        tableData: [],/*列表数据*/
        totalDataNumber: 0,/*总条数*/
        pageSize: 20,/*一页多少条*/
        curPage: 1,/*当前是第几页*/

        /*是否打开添加弹窗*/
        open_add: false,
        open_edit: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },

      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
       // 选项卡 start
       handleClick(tab, event) {
         /*切换选项卡 */
         let self = this;
         self.curPage = 1; //变为第一页
         self.loading = true;//加载中
         self.activeName = tab.name;
         self.getData(); //获取数据
       },
       // 选项卡 end


       /*搜索查询*/
       onSubmit() {
         let self = this;
         self.loading = true;//加载中
         self.getData();//获取数据
       },

      //列表数据 start

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val; //选择的页数
        self.loading = true; //加载中
        self.getData();//获取数据
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;  //调到第一页
        this.pageSize = val; //每页多少条
        this.getData(); //获取数据
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params = self.searchForm; //搜索
        Params.activeStatus = self.activeName; //选项卡
        Params.page = self.curPage; //当前页数
        Params.list_rows = self.pageSize;//每页多少条

        //请求接口
        RankingApi.List(Params, true).then(res => {
          self.loading = false;//加载结束
          self.tableData = res.data.list.data; //把数据给列表
          self.totalDataNumber = res.data.list.total;//一共多少条

        }).catch(error => {
          self.loading = false; //加载结束
        });
      },

      //列表数据 end

      //操作 start


      /*删除*/
      delClick: function(row) {
        let self = this;
        self.loading = true;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          RankingApi.Del({
            ranking_id: row.ranking_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          }).catch(() =>{
            self.loading = false;
          });
        }).catch(() =>{
          self.loading = false;
        });
      },

      //操作 end
      /*打开添加*/
      addClick() {
        this.Oneform.model = {};
        this.Oneform.type = 'add';
        this.open_add = true;
      },
      //编辑
      editClick($row){
        this.Oneform.model = $row;
        this.Oneform.type = 'edit';
        this.agent = $row;
        this.open_edit = true;
      },
      //详情
      dateilClick($row){
        this.Oneform.model = $row;
        this.Oneform.type = 'dateil';
        this.open_add = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.open_add = e.openDialog;
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ranking/index/list.vue